import { render } from "./HistoricTab.vue?vue&type=template&id=e7f53660"
import script from "./HistoricTab.vue?vue&type=script&lang=js"
export * from "./HistoricTab.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__